import React, { useState } from "react";
import { Paragraph, Subtitle } from "../components/misc/Typography";
import { CheckList, CheckListItemSubtitle, Price } from "../components/user/PriceCard";
import { formatMb } from "../components/user/UserWidget";
import { MAX_UPLOADS, setUserSettings } from "../firebase/firestore";
import useAuth from "../hooks/useAuth";
import Select from "react-select";
import { forceUserWeeklies } from "../firebase/functions";
interface ILabeledInputProps {
  label: string;
  subLabel?: string;
  children: React.ReactNode;

  [key: string]: any;
}
export function LabeledInput({ children, label, subLabel, ...rest }: ILabeledInputProps) {
  return (
    <div {...rest}>
      <div>{label}</div>
      <div className="mb-2">
        <CheckListItemSubtitle className="mt-0 mb-4">{subLabel}</CheckListItemSubtitle>
      </div>
      {children}
    </div>
  );
}

export function CheckboxSetting({ value, changeValue, label, subLabel, ...rest }) {
  return (
    <div {...rest}>
      <div className="flex">
        <input type={"checkbox"} className={`shrink-0 mt-1 mr-2 w-4 h-4`} checked={value} onChange={changeValue} />
        <div>
          <div>{label}</div>
          <div>
            <CheckListItemSubtitle className="mt-0 mb-4">{subLabel}</CheckListItemSubtitle>
          </div>
        </div>
      </div>
    </div>
  );
}

const StyledSelect = ({ loading, ...rest }) => (
  <div style={{ width: 200 }} className="relative">
    {loading && <Shimmer style={{ borderRadius: 2 }} />}
    <Select
      {...rest}
      styles={{
        control: (provided, state) => ({
          // none of react-select's styles are passed to <Control />
          ...provided,
          width: 200,
          background: "#1d1d1d",
          border: "#616161 1px solid",
        }),
        menu: (provided, state) => ({
          ...provided,
          width: 200,
          background: "#333333",
        }),
        option: (provided, state) => ({
          ...provided,
          background: state.isSelected ? "#222222" : "#333333",
          "&:hover": {
            background: "#696969",
          },
        }),
        singleValue: (provided, state) => ({
          ...provided,
          color: "white",
        }),
      }}
    />
  </div>
);
const Shimmer = (props) => <div {...props} className="shimmer-overlay opacity-10" />;
export function SelectSetting({ options, value, setValue, label, className = "", ...rest }) {
  const [loading, setLoading] = useState(false);
  const onChange = async (v) => {
    setLoading(true);
    await setValue(v.value);
    setLoading(false);
  };
  return (
    <div className={className + ` flex items-center ${loading && " loading"}`}>
      <div className="mr-4">{label}</div>
      <StyledSelect {...rest} options={options} value={value} onChange={onChange} loading={loading} />
    </div>
  );
}

export default function settings() {
  const { user } = useAuth();
  const onSetAnalyze = (e) => {
    console.log(e.target.checked);
    setUserSettings(user.uid, { ...user.settings, analyze_files: e.target.checked });
  };
  return (
    <div className="text-left px-2 md:px-6 py-6 md:py-12">
      <Subtitle left className="text-4xl mb-4">
        Settings
      </Subtitle>
      <CheckboxSetting
        label="Analyze files"
        style={{ maxWidth: 500 }}
        subLabel={
          <span>
            Automatically analyze filenames and audio of your tracks to detect key and bpm. If this is off, you can
            still add this info manually.
          </span>
        }
        value={user?.settings?.analyze_files === false ? false : true}
        changeValue={onSetAnalyze}
      />
      <div>
        <Subtitle left>Your Plan</Subtitle>
      </div>
      <div className="flex flex-wrap justify-around">
        <Price
          title="Free"
          plan={"free"}
          owns={user?.plan === "free"}
          descr={<CheckList items={[formatMb(MAX_UPLOADS["free"])]} />}
        />
        <Price
          title="Member"
          plan="member"
          price={`$8.08`}
          owns={user?.plan === "member"}
          descr={
            <CheckList
              items={[
                formatMb(MAX_UPLOADS["member"]),
                [
                  "Custom links",
                  <span>
                    Links start with <i>your-name.beatpacks.app</i>
                  </span>,
                ],
                ["Untagged filenames"],
              ]}
            />
          }
        />
        <Price
          title="Platinum"
          plan="platinum"
          price={`$20`}
          owns={user?.plan === "platinum"}
          descr={
            <CheckList
              items={[
                formatMb(MAX_UPLOADS["platinum"]),
                [
                  "Custom links",
                  <span>
                    Links start with <i>your-name.beatpacks.app</i>
                  </span>,
                ],
                ["Untagged filenames"],
                ["Automatic emails", "Slick emails sent to your pack recepients"],
              ]}
            />
          }
        />
      </div>
      {/* <Subtitle left>Profile</Subtitle>
        <div className='pt-4 '>
            <NicknameInput className={` w-96`}/>
        </div> */}
    </div>
  );
}
